import en from './en.json';
import fr from './fr.json';

export default {
  'en-uk': en,
  'en-ca': en,
  'en-us': en,
  'fr-ca': fr,
  en,
  fr,
};
